import React, { useState, useEffect, useMemo } from "react";
// import { LoadingOutlined } from '@ant-design/icons';
// import { Spin } from 'antd';
import { Switch, Route, useHistory } from "react-router-dom";
import Topbar from "../../borrower/global/Topbar";
import Sidebar from "../../borrower/global/Sidebar";
import Dashboard from "../../borrower/dashboard";
import ApplyLoan from "../../borrower/loan/apply-loan";
import LoanHub from "../../borrower/loan/loan-hub";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "../../theme";
import Loan from "../../borrower/loan/loan";
import OngoingLoans from "../../borrower/loan/ongoing-loans";
import RequestedLoans from "../../borrower/loan/pending-loans";
import Agreements from "../../borrower/agreements";
import Transactions from "../../borrower/transactions";
import Profile from "../../borrower/profile";
import { Link } from "react-router-dom";
import AcceptedLoans from "../../borrower/loan/accepted-loan";
import { SearchProvider } from "../../admin/search-context";
import SidebarMobile from "../../borrower/global/SidebarMobile";
import DashboardMobile from "../../borrower/borrower_mobile/dashboard_mobile";
import Cookies from "js-cookie";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ProfileStaging from "../../borrower/profile staging";
import Messaging from "../../borrower/loan/message";
import CbsCampagin from "./CbsCampaign";
import DocumentVault from "./DocumentVault";
import PropertyTermLoan from "./PropertyTermLoan";
import PersonalLoans from "./PersonalLoans";
import BauthConf from "../../borrower/profile staging/bauthconf";
import { Button, Modal, message, ConfigProvider } from "antd";

import { borrowerAntTheme, createBorrowerTheme } from "./borrower-theme";
import "./borrower-rebrand.css";

const MONEY_LENDER_CAMPAIGN_COOKIE = "money_lender_campaign_data";
const MONEY_LENDER_CAMPAIGN_DISMISSED_COOKIE =
  "money_lender_campaign_dismissed";
const hasMyInfoPayload = (value) => {
  if (!value) return false;

  if (typeof value === "string") {
    const normalized = value.trim();
    return (
      normalized.length > 0 &&
      normalized !== "null" &&
      normalized !== "{}" &&
      normalized !== "[]"
    );
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === "object") {
    return Object.keys(value).length > 0;
  }

  return Boolean(value);
};

// const antIcon = (
//   <LoadingOutlined
//     style={{
//       fontSize: 24,
//     }}
//     spin
//   />
// );

function DashboardBorrowerLayout() {
  const history = useHistory();
  const [theme, colorMode] = useMode();
  const borrowerTheme = useMemo(() => createBorrowerTheme(theme), [theme]);
  useEffect(() => {
    document.body.classList.add("sl-borrower-theme");
    return () => document.body.classList.remove("sl-borrower-theme");
  }, []);
  const [isSidebar, setIsSidebar] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = React.useState("");
  const [topNotification, setTopNotification] = useState(null);
  const [screenWidth, setScreenWidth] = useState("1920");
  const [showPersonalLoanPrompt, setShowPersonalLoanPrompt] = useState(false);
  const [personalLoanPromptSource, setPersonalLoanPromptSource] =
    useState("default");
  const [campaignSingpassBusy, setCampaignSingpassBusy] = useState(false);
  // const handleRouteClic  k = () => {
  //   setIsLoading(true);
  //   // You can add a timeout here to simulate a loading process
  //   setTimeout(() => {
  //     setIsLoading(false);
  //   }, 5000);
  // };
  useEffect(() => {
    console.log("setting token param");
    // Function to get the value of a URL parameter by name
    const getUrlParameter = (name) => {
      name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      const results = regex.exec(window.location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    // Get the token parameter from the URL
    const tokenParam = getUrlParameter("token");

    // Check if a token is present in the URL
    if (tokenParam) {
      // Store the token in cookies
      console.log(tokenParam);
      Cookies.set("token", tokenParam, { expires: 720 }); // Set an expiration if needed
    }
  }, []);


  const fetchNotification = async (loan_id) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/notification/createLogNotify`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      const json = await response.json();

      if (response.status === 200) {
        const notificationsForTopBar = json["new_notifications"];
        const lateRepayIndex = notificationsForTopBar.findIndex(
          (notification) => notification.type === "late_repay"
        );

        if (lateRepayIndex > -1) {
          setTopNotification(notificationsForTopBar[lateRepayIndex]);
        } else if (notificationsForTopBar.length > 0) {
          setTopNotification(notificationsForTopBar[0]);
        } else {
          setTopNotification(null);
        }

        console.log(json["new_notifications"]);
        console.log(Cookies.get("token"));
      }
    } catch (error) {
      if (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (screenWidth > 1200) {
      fetchNotification();
    }
  }, []);
  useEffect(() => {
    if (screenWidth <= 1200) {
      setTopNotification(null);
    }
  }, [screenWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [userDetails, setUserDetails] = useState(null);


  useEffect(() => {
    const shouldShowCampaignPostSyncPrompt = sessionStorage.getItem(
      "showCampaignPersonalLoanPrompt"
    );
    const shouldShowPrompt = sessionStorage.getItem("showPersonalLoanPrompt");
    const hasCampaignCookie = Boolean(Cookies.get(MONEY_LENDER_CAMPAIGN_COOKIE));
    const campaignDismissed =
      Cookies.get(MONEY_LENDER_CAMPAIGN_DISMISSED_COOKIE) === "true";
    const hasExistingMyInfoData =
      hasMyInfoPayload(userDetails?.myinfo_data) ||
      hasMyInfoPayload(userDetails?.singpass_data) ||
      String(userDetails?.singpass_sync || "") === "1";

    if (shouldShowCampaignPostSyncPrompt === "true") {
      setPersonalLoanPromptSource("money_lender_campaign_post_sync");
      setShowPersonalLoanPrompt(true);
      sessionStorage.removeItem("showCampaignPersonalLoanPrompt");
      sessionStorage.removeItem("showPersonalLoanPrompt");
      return;
    }

    if (shouldShowPrompt === "true") {
      setPersonalLoanPromptSource("default");
      setShowPersonalLoanPrompt(true);
      sessionStorage.removeItem("showPersonalLoanPrompt");
      return;
    }

    if (hasCampaignCookie && !campaignDismissed) {
      setPersonalLoanPromptSource(
        hasExistingMyInfoData
          ? "money_lender_campaign_post_sync"
          : "money_lender_campaign_sync"
      );
      setShowPersonalLoanPrompt(true);
    }
  }, [userDetails]);
  
  const getUserDetails = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/getUserDetails",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.status === 200) {
        const json = await response.json();
        setUserDetails(json.User);
        Cookies.set("email", json.User.email);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  const handleCampaignSingpassSync = async () => {
    try {
      setCampaignSingpassBusy(true);
      const token = Cookies.get("token");
      if (!token) {
        history.push("/auth/signin");
        return;
      }

      Cookies.remove(MONEY_LENDER_CAMPAIGN_DISMISSED_COOKIE, { path: "/" });
      Cookies.set("sync_source", "money_lender_campaign", {
        path: "/",
        expires: 30,
      });

      const response = await fetch(
        "https://www.smart-lend.com/api/generateCodeChallenge",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ type: "borrower" }),
        }
      );

      const json = await response.json();
      if (response.ok && json?.singpass_url && json?.session_id) {
        Cookies.set("latest_session_id", json.session_id, { path: "/" });
        window.location.href = json.singpass_url;
        return;
      }

      throw new Error(json?.message || "Unable to start Singpass sync");
    } catch (error) {
      console.error(error);
      message.error("Unable to start Singpass sync right now. Please try again.");
    } finally {
      setCampaignSingpassBusy(false);
    }
  };

  const handleDismissCampaignFlow = () => {
    Cookies.set(MONEY_LENDER_CAMPAIGN_DISMISSED_COOKIE, "true", {
      path: "/",
      expires: 30,
    });
    Cookies.remove(MONEY_LENDER_CAMPAIGN_COOKIE, { path: "/" });
    Cookies.remove("sync_source", { path: "/" });
    sessionStorage.removeItem("showCampaignPersonalLoanPrompt");
    setShowPersonalLoanPrompt(false);
  };

  const isMobileLayout = screenWidth <= 1200;

  return (
    <SearchProvider value={{ search, setSearch }}>
      <ColorModeContext.Provider value={colorMode}>
        <ConfigProvider theme={borrowerAntTheme}>
        <ThemeProvider theme={borrowerTheme}>
          <CssBaseline />
          <Modal
            width="45%"
            visible={showPersonalLoanPrompt}
            onCancel={() => setShowPersonalLoanPrompt(false)}
            footer={null}
          >
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 26, fontWeight: 800, color: "var(--br-primary, #0e5aa5)" }}>
                {personalLoanPromptSource === "money_lender_campaign_sync"
                  ? "Continue your campaign application"
                  : personalLoanPromptSource === "money_lender_campaign_post_sync"
                  ? "You're all set"
                  : "Congrats!"}
              </div>
              <div style={{ color: "rgba(0,0,0,0.6)", marginTop: "10px" }}>
                {personalLoanPromptSource === "money_lender_campaign_sync"
                  ? "We noticed you came from our money lender campaign. Would you like to proceed with your application by syncing Singpass MyInfo now?"
                  : personalLoanPromptSource === "money_lender_campaign_post_sync"
                  ? "Your Singpass MyInfo data is synced successfully. Continue to personal loans to complete your application."
                  : "You've successfully retrieved your data from Singpass MyInfo. Would you like to proceed to apply for a personal loan?"}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 12,
                  marginTop: 20,
                  flexWrap: "wrap",
                }}
              >
                <Button
                  type="primary"
                  disabled={campaignSingpassBusy}
                  onClick={() => {
                    if (personalLoanPromptSource === "money_lender_campaign_sync") {
                      handleCampaignSingpassSync();
                      return;
                    }

                    Cookies.set(MONEY_LENDER_CAMPAIGN_DISMISSED_COOKIE, "true", {
                      path: "/",
                      expires: 30,
                    });
                    if (
                      personalLoanPromptSource !== "money_lender_campaign_post_sync"
                    ) {
                      Cookies.remove(MONEY_LENDER_CAMPAIGN_COOKIE, {
                        path: "/",
                      });
                    }
                    Cookies.remove("sync_source", { path: "/" });
                    sessionStorage.removeItem("showCampaignPersonalLoanPrompt");
                    setShowPersonalLoanPrompt(false);
                    history.push("/b-personal-loans");
                  }}
                  style={{
                    background:
                      "linear-gradient(135deg, var(--br-primary, #0e5aa5) 0%, #6d5cf6 120%)",
                    border: "none",
                    fontWeight: 700,
                  }}
                >
                  {personalLoanPromptSource === "money_lender_campaign_sync"
                    ? campaignSingpassBusy
                      ? "Starting sync..."
                      : "Sync Singpass"
                    : personalLoanPromptSource === "money_lender_campaign_post_sync"
                    ? "Continue to personal loans"
                    : "Apply personal loan"}
                </Button>
                <Button
                  onClick={() => {
                    if (personalLoanPromptSource === "money_lender_campaign_sync") {
                      handleDismissCampaignFlow();
                      return;
                    }

                    setShowPersonalLoanPrompt(false);
                  }}
                >
                  Stay on dashboard
                </Button>
              </div>
            </div>
          </Modal>
          <div
            className="app sl-borrower-shell"
            style={{
              overflow: "hidden",
              flexDirection: isMobileLayout ? "column" : "row",
              background:
                isMobileLayout
                  ? "var(--br-card-surface, transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box)"
                  : "transparent",
            }}
          >
            <div
              className="sl-borrower-sidebar-slot"
              style={{
                position: "relative",
                marginTop: "0px",
                width: isMobileLayout ? "100%" : "15%",
                zIndex: isMobileLayout ? 5 : "auto",
              }}
            >
              <Sidebar isSidebar={isSidebar} userDetails={userDetails} />
            </div>
            <main
              className="content sl-borrower-content"
              style={{
                overflowY: isMobileLayout ? "auto" : "auto",
                height: isMobileLayout ? "auto" : window.innerHeight,
                width: isMobileLayout ? "100%" : "85%",
              }}
            >
              {/* {screenWidth > 1200 ? (
                topNotification ? (
                  <div
                    style={{
                      width: "100%",
                      height: "5vh",
                      background:
                        topNotification.color === "red" ? "#80160b" : "#0a58ca",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <ErrorOutlineIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        margin: "0px 10px 0px 10px",
                      }}
                    />
                    <div
                      style={{
                        fontSize: "12px",
                        color: "white",
                        margin: "0px 10px 0px 0px",
                      }}
                    >
                      {topNotification.message}
                    </div>
                    <a
                      className="all_button"
                      style={{
                        fontSize: "12px",
                        color: "white",
                        border: "1px solid white",
                        borderRadius: "20px",
                        background: "transparent",
                        padding: "3px 22px",
                        margin: "0px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                      href={
                        topNotification.type === "late_repay"
                          ? "/b-loan-in-progress"
                          : topNotification.type === "pending_sign"
                          ? "/b-agreements"
                          : "/b-requested-loans"
                      }
                    >
                      View All
                    </a>
                  </div>
                ) : null
              ) : null} */}
              <Topbar setIsSidebar={setIsSidebar} userDetails={userDetails} />
              {/* {isLoading && <Spin indicator={antIcon} />} */}
              <div className="sl-borrower-page">
              <Switch>
                <Route path="/b-dashboard" component={Dashboard} />
                <Route path="/b-auth-conf" component={BauthConf} />
                <Route path="/b-loan" component={Loan} />
                <Route path="/b-loan-hub" component={LoanHub} />
                <Route path="/b-apply-loan" component={ApplyLoan} />
                <Route path="/b-loan-in-progress" component={OngoingLoans} />
                <Route path="/b-requested-loans" component={RequestedLoans} />
                <Route path="/b-accepted-loans" component={AcceptedLoans} />
                <Route path="/b-agreements" component={Agreements} />
                <Route path="/b-transactions" component={Transactions} />
                <Route path="/b-profile" component={ProfileStaging} />
                <Route path="/stg-b-profile" component={ProfileStaging} />
                <Route path="/b-messages" component={Messaging} />
                <Route path="/b-cbs-campaign" component={CbsCampagin} />
                <Route
                  path="/b-instant-prop-term-loan"
                  component={PropertyTermLoan}
                />
                <Route path="/b-personal-loans" component={PersonalLoans} />
                <Route path="/b-document-vault" component={DocumentVault} />
                <Route path="/dashboard-mobile" component={DashboardMobile} />
                <Route path="/sidebar-mobile" component={SidebarMobile} />
              </Switch>
              </div>
            </main>
          </div>
        </ThemeProvider>
        </ConfigProvider>
      </ColorModeContext.Provider>
    </SearchProvider>
  );
}

export default DashboardBorrowerLayout;
